<h3 class="title-divider">{{ "bearbeitetstatusHeading" | translate }}</h3>
<cap-form-control labelKey="Rechtsgültig">
  <input
    (ngModelChange)="model && (model.rechtsgueltig = $event)"
    [ngModel]="model && model.rechtsgueltig"
    id="rechtsgueltig"
    name="status.rechtsgueltig"
    type="checkbox" />
</cap-form-control>
<cap-form-control labelKey="Hängig">
  <input
    (ngModelChange)="model && (model.haengig = $event)"
    [ngModel]="model && model.haengig"
    id="haengig"
    name="status.haengig"
    type="checkbox" />
</cap-form-control>
